import { modules } from '@valbuild/next';
import { config } from './val.config';

export default modules(config, [
  { def: () => import('./app/(main)/arbeider/[slug]/page.val') },
  { def: () => import('./app/(main)/arbeider/page.val') },
  { def: () => import('./app/(main)/jobb/[slug]/page.val') },
  { def: () => import('./data/employees.val') },
  { def: () => import('./data/benefits.val') },
  { def: () => import('./data/salary.val') },
  { def: () => import('./app/(main)/om-oss/page.val') },
  { def: () => import('./app/(main)/events/[slug]/page.val') },
  { def: () => import('./app/(main)/jobb/page.val') },
  { def: () => import('./app/(main)/kaffeprat/page.val') },
  { def: () => import('./app/(main)/handboka/page.val') },
  { def: () => import('./app/(main)/tjenester/page.val') },
  { def: () => import('./app/(main)/menneskene/page.val') },
  { def: () => import('./app/(main)/prosjektprat/page.val') },
  { def: () => import('./settings/darkside.val') },
  { def: () => import('./settings/notFound.val') },
  { def: () => import('./settings/header.val') },
  { def: () => import('./settings/footer.val') },
  { def: () => import('./settings/contactSales.val') },
  { def: () => import('./settings/contactUs.val') },
  { def: () => import('./settings/projectSummary.val') },
  { def: () => import('./externalPages.val') },
  { def: () => import('./app/(main)/page.val') },
  { def: () => import('./app/(main)/kaffeprat/feil/page.val') },
  { def: () => import('./app/(main)/kaffeprat/takk/page.val') },
  { def: () => import('./settings/eventSeries.val') },
  { def: () => import('./settings.val') },
]);
